module.exports = __webpack_public_path__ + "static/media/NZL.cd6d53c6.png";